import { Box, Stack, StackProps } from '@mui/material'
import { FC } from 'react'
import Carousel from 'react-material-ui-carousel'

import { InspectionMediaEntry, RepairOrderMediaEntry } from '../../sdk'
import { convert1DArrayTo2D } from '../../utils/convert1DArrayTo2D/convert1DArrayTo2D'
import { ImageBoxUI } from './MediaGallaryUI'

export enum MediaEntryType {
  inspectionPrompt,
  repairOrder
}

interface Props {
  media: InspectionMediaEntry[] | RepairOrderMediaEntry[]
}

const imageGroupProps: StackProps = {
  spacing: 1,
  direction: 'row',
  sx: {
    width: '100%',
    height: '100%'
  }
}

const MediaGalleryReadOnly: FC<Props> = ({ media }) => {
  return (
    <Box sx={{ width: '100%' }}>
      <Carousel autoPlay={false} navButtonsAlwaysVisible height="300px">
        {convert1DArrayTo2D(media, 2).map((group, index) => (
          <Stack key={index} {...imageGroupProps}>
            {group.map((entry) => (
              <ImageBoxUI
                key={entry.id!}
                src={entry.thumbnailUrl!}
                alt={entry.info!.description}
                readOnly={true}>
                <></>
              </ImageBoxUI>
            ))}
          </Stack>
        ))}
      </Carousel>
    </Box>
  )
}

export default MediaGalleryReadOnly
